import { AnalyticEvents } from "@fresh8/types/src/analytics";

function promiseImageLoad(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = document.createElement("img");
    img.classList.add("f8P");
    img.src = src;
    img.height = 0;
    img.width = 0;
    img.style.display = "none";

    img.addEventListener("error", e => reject(e));
    img.addEventListener("load", () => resolve());
    document.body.appendChild(img);
  });
}

function promiseIFrameLoad(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement("iframe");
    iframe.classList.add("f8P");
    iframe.src = src;
    iframe.style.height = "0";
    iframe.style.width = "0";
    iframe.style.display = "none";

    iframe.addEventListener("error", e => reject(e));
    iframe.addEventListener("load", () => resolve());
    document.body.appendChild(iframe);
  });
}

/**
 * Fires a pixel using ajax/appending images to the DOM based on the event type
 * @param  {Object} pixels    is the pixels object containing the thrird party pixels
 * @param  {String} eventName is to fire the pixel for
 * @return {AxiosPromise}
 */
async function firePixel(
  pixelUrl: string,
  eventName: string,
  pixelType = "image"
) {
  if (eventName && eventName === AnalyticEvents.CLICKED_THROUGH) {
    return await fetch(pixelUrl, {
      method: "GET",
      credentials: "include"
    });
  } else if (
    eventName &&
    (eventName === AnalyticEvents.VIEWED ||
      eventName === AnalyticEvents.IMPRESSION)
  ) {
    return pixelType === "image"
      ? await promiseImageLoad(pixelUrl)
      : await promiseIFrameLoad(pixelUrl);
  }
}

export default function pixel(
  pixelUrl: string,
  statsEventName: AnalyticEvents,
  pixelType: "image" | "iframe" = "image",
  refireAfter?: number
) {
  // checking if the analytics is enabled
  let analyticsEnabled: boolean;
  const urlParams = new URLSearchParams(window.location.search);
  const analyticsDisabled = urlParams.get("analyticsDisabled") || undefined;
  if (analyticsDisabled) {
    analyticsEnabled = analyticsDisabled !== "true";
  } else {
    analyticsEnabled = process.env.NODE_ENV === "production";
  }
  if (!analyticsEnabled) return;

  // refire pixel logic
  if (refireAfter) {
    setTimeout(async () => {
      try {
        await firePixel(pixelUrl, statsEventName, pixelType);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }, refireAfter * 1000);
  }
  // Fire clickthroughUrl in the background or create an impression pixel
  return firePixel(pixelUrl, statsEventName, pixelType);
}
